import { useEffect, useState } from 'react';

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      aria-label="返回顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className="fixed bottom-6 right-4 md:right-8 z-40 w-11 h-11 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-lg hover:bg-primary-600 transition-colors cursor-pointer"
    >
      <i className="ri-arrow-up-line" />
    </button>
  );
}